import { useQuery } from '@tanstack/react-query';
import type { GroupInviteDto } from '@mondy/shared';
import { api } from '@/api';

interface GroupInvitesResponse {
  invites: GroupInviteDto[];
}

/**
 * Owner-only pending-invites list. Only fetch when a row is expanded by an
 * owner (the server returns 403 otherwise) — gate with the `enabled` flag.
 */
export function useGroupInvites(groupId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['groups', 'invites', groupId] as const,
    queryFn: () =>
      api.get<GroupInvitesResponse>(`/api/groups/${groupId}/invites`),
    enabled: Boolean(groupId) && enabled,
    staleTime: 30_000,
  });
}
